<form [formGroup]="form" (submit)="submitForm()" appDebounceTime>
	<div class="row input-group">
		<div class="col-12">
			<app-form-control
				isRequired="true"
				label="Subject"
				[errors$]="errorService.errorsFor('subject')"
			>
				<div>
					<input
						type="text"
						class="form-control"
						placeholder="Subject"
						formControlName="subject"
					/>
				</div>
			</app-form-control>
		</div>
	</div>
	<div class="row input-group">
		<div class="col-12">
			<app-form-control
				label="Feedback"
				isRequired="true"
				[errors$]="errorService.errorsFor('body')"
			>
				<textarea
					class="form-control"
					formControlName="body"
					placeholder="Feedback..."
					rows="5"
				></textarea>
			</app-form-control>
		</div>
	</div>
	<div class="row input-group">
		<div class="col-12 col-lg-6 offset-lg-6">
			<button type="submit" class="fm-btn fm-btn--filled btn-block">
				Submit
			</button>
		</div>
	</div>
</form>
